export const isMobileDevice = (): boolean => {
    const result = navigator.userAgent.match(/Android|iPhone|iPad/i);

    if (result && result.length > 0) {
        return true;
    }

    return false;
};
